__turbopack_context__.v({
  "emailInput": "InputEmail-module-scss-module__6QX4pa__emailInput",
  "helperText": "InputEmail-module-scss-module__6QX4pa__helperText",
  "hiddenInput": "InputEmail-module-scss-module__6QX4pa__hiddenInput",
  "inputIndicator": "InputEmail-module-scss-module__6QX4pa__inputIndicator",
  "root": "InputEmail-module-scss-module__6QX4pa__root",
  "suggestedEmail": "InputEmail-module-scss-module__6QX4pa__suggestedEmail",
});
